import { connect } from 'react-redux';
import { bindActionCreators, Dispatch, Action } from 'redux';

import { StateType } from 'types';
import { setIsDrawerOpen } from 'redux/actions/workspace';
import { selectAdgmLicenseByTechnicalLicenseId, selectTechnicalLicenseId, selectTechnicalLicenseDetails } from 'redux/selectors/technicalLicenses';
import { getADGMLicenseByTechnicalLicenseId, updateTechnicalLicenseById } from 'redux/actions/technicalLicense';
import { selectUserTechnicalLicenseId, selectUserType } from 'redux/selectors/auth'

const mapStateToProps = (state: StateType) => ({
  adgm: selectAdgmLicenseByTechnicalLicenseId(state),
  userTechnicalLicenseId: selectUserTechnicalLicenseId(state),
  userType: selectUserType(state),
  id: selectTechnicalLicenseId(state),
  info: selectTechnicalLicenseDetails(state),
});

const mapDispatchToProps = (dispatch: Dispatch<Action>) => ({
  actions: bindActionCreators({
    getADGMLicenseByTechnicalLicenseId,
    updateTechnicalLicenseById,
    setIsDrawerOpen,
  }, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps);
